document.addEventListener('DOMContentLoaded', () => {
    initLanguageSwitchers();
    initSiteAnchorNavigation();

    initHeroSliders()

    initProductsShowcases(); //dots + swipe

    initCareersFilters(); // filters
    initCareersJobFilters();

    console.log('[WinAndYou Redesign] JavaScript loaded');
});

function initLanguageSwitchers() {
    const switchers = document.querySelectorAll(
        '[data-language-switcher]'
    );

    if (!switchers.length) {
        return;
    }

    const closeSwitcher = (switcher) => {
        const trigger = switcher.querySelector(
            '[data-language-trigger]'
        );

        switcher.classList.remove('is-open');

        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
    };

    const closeAllSwitchers = (exception = null) => {
        switchers.forEach((switcher) => {
            if (switcher !== exception) {
                closeSwitcher(switcher);
            }
        });
    };

    switchers.forEach((switcher) => {
        const trigger = switcher.querySelector(
            '[data-language-trigger]'
        );

        if (!trigger) {
            console.warn(
                '[Language switcher] Trigger not found',
                switcher
            );

            return;
        }

        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const shouldOpen = !switcher.classList.contains('is-open');

            closeAllSwitchers(switcher);

            switcher.classList.toggle('is-open', shouldOpen);

            trigger.setAttribute(
                'aria-expanded',
                String(shouldOpen)
            );
        });
    });

    document.addEventListener('click', (event) => {
        switchers.forEach((switcher) => {
            if (!switcher.contains(event.target)) {
                closeSwitcher(switcher);
            }
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }

        switchers.forEach((switcher) => {
            const trigger = switcher.querySelector(
                '[data-language-trigger]'
            );

            if (switcher.classList.contains('is-open')) {
                closeSwitcher(switcher);
                trigger?.focus();
            }
        });
    });
}


function initSiteAnchorNavigation() {
    const anchorLinks = document.querySelectorAll(
        '[data-site-navigation] a[href*="#"]'
    );

    if (!anchorLinks.length) {
        return;
    }

    const sections = new Map();

    const setActiveAnchor = (targetId) => {
        anchorLinks.forEach((link) => {
            try {
                const url = new URL(
                    link.href,
                    window.location.origin
                );

                link.classList.toggle(
                    'is-active',
                    url.hash === `#${targetId}`
                );
            } catch (error) {
                console.warn(
                    '[Site navigation] Invalid URL:',
                    link.href
                );
            }
        });
    };

    anchorLinks.forEach((link) => {
        try {
            const url = new URL(
                link.href,
                window.location.origin
            );
            const targetId = url.hash.slice(1);

            if (!targetId) {
                return;
            }

            const section = document.getElementById(targetId);

            if (!section) {
                return;
            }

            sections.set(targetId, section);
        } catch (error) {
            console.warn(
                '[Site navigation] Invalid URL:',
                link.href
            );
        }
    });

    if (sections.size) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    setActiveAnchor(entry.target.id);
                });
            },
            {
                root: null,
                rootMargin: '-50% 0px -50% 0px',
                threshold: 0,
            }
        );

        sections.forEach((section) => {
            observer.observe(section);
        });
    }

    scrollToCurrentHash();
}


function scrollToCurrentHash() {
    if (!window.location.hash) {
        return;
    }

    window.setTimeout(() => {
        const targetId = window.location.hash.slice(1);
        const targetElement = document.getElementById(targetId);

        if (!targetElement) {
            return;
        }

        const header = document.querySelector('.site-header');
        const headerHeight = header?.offsetHeight ?? 0;

        const targetPosition =
            targetElement.getBoundingClientRect().top
            + window.scrollY
            - headerHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
        });
    }, 300);
}


function initHeroSliders() {
    const sliderConfigs = [
        {
            rootSelector: "[data-home-hero]",
            sliderSelector: "[data-home-hero-slider]",
            paginationSelector:
                "[data-home-hero-pagination]",
            bulletClass:
                "home-hero__pagination-dot",
            name: "Home Hero",
        },
        {
            rootSelector: "[data-about-hero]",
            sliderSelector:
                "[data-about-hero-slider]",
            paginationSelector:
                "[data-about-hero-pagination]",
            bulletClass:
                "about-hero__pagination-dot",
            name: "About Hero",
        },
    ];

    if (typeof window.Swiper !== "function") {
        console.warn(
            "[Hero Slider] Swiper is not loaded"
        );

        return;
    }

    sliderConfigs.forEach(config => {
        const roots = document.querySelectorAll(
            config.rootSelector
        );

        roots.forEach(root => {
            const slider = root.querySelector(
                config.sliderSelector
            );

            if (!slider || slider.swiper) {
                return;
            }

            const pagination = root.querySelector(
                config.paginationSelector
            );

            new window.Swiper(slider, {
                slidesPerView: 1,

                speed: 600,

                rewind: true,

                grabCursor: true,

                watchOverflow: true,

                effect: "fade",

                fadeEffect: {
                    crossFade: true,
                },

                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },

                pagination: pagination
                    ? {
                        el: pagination,
                        clickable: true,
                        bulletClass:
                            config.bulletClass,
                        bulletActiveClass:
                            "is-active",
                    }
                    : undefined,

                a11y: true,

                on: {
                    beforeTransitionStart() {
                        root.classList.add(
                            "is-transitioning"
                        );
                    },

                    transitionEnd() {
                        root.classList.remove(
                            "is-transitioning"
                        );
                    },
                },
            });
        });
    });
}

// dots + swipe
function initProductsShowcases() {
    const showcases = document.querySelectorAll(
        '[data-products-showcase]'
    );

    if (!showcases.length) {
        return;
    }

    const tabletMedia = window.matchMedia(
        '(min-width: 768px) and (max-width: 1199px)'
    );

    showcases.forEach((root) => {
        const viewport = root.querySelector(
            '[data-products-viewport]'
        );

        const track = root.querySelector(
            '[data-products-track]'
        );

        const cards = [
            ...root.querySelectorAll(
                '[data-products-card]'
            ),
        ];

        const dots = [
            ...root.querySelectorAll(
                '[data-products-dot]'
            ),
        ];

        if (
            !viewport
            || !track
            || cards.length < 2
        ) {
            return;
        }

        const playCardReveal = (card) => {
            if (!card) {
                return;
            }

            card.classList.remove('is-switching-in');

            void card.offsetWidth;

            card.classList.add('is-switching-in');

            window.setTimeout(() => {
                card.classList.remove('is-switching-in');
            }, 750);
        };

        let activeIndex = 0;
        let pointerStartX = null;

        const updatePosition = () => {
            if (!tabletMedia.matches) {
                track.style.transform = '';

                return;
            }

            const maxShift = Math.max(
                0,
                track.scrollWidth
                - viewport.clientWidth
            );

            const shift =
                activeIndex === 0
                    ? 0
                    : -maxShift;

            track.style.transform =
                `translate3d(${shift}px, 0, 0)`;
        };


        const updateDots = () => {
            dots.forEach((dot, index) => {
                const isActive =
                    index === activeIndex;

                dot.classList.toggle(
                    'is-active',
                    isActive
                );

                if (isActive) {
                    dot.setAttribute(
                        'aria-current',
                        'true'
                    );
                } else {
                    dot.removeAttribute(
                        'aria-current'
                    );
                }
            });
        };


        const goTo = (index, animate = true) => {
            activeIndex = Math.max(
                0,
                Math.min(index, cards.length - 1)
            );

            updatePosition();
            updateDots();

            // Replay the active card reveal on tablet switches only.
            if (animate && tabletMedia.matches) {
                playCardReveal(cards[activeIndex]);
            }
        };


        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                goTo(index);
            });
        });


        viewport.addEventListener(
            'pointerdown',
            (event) => {
                if (!tabletMedia.matches) {
                    return;
                }

                pointerStartX = event.clientX;
            }
        );


        viewport.addEventListener(
            'pointerup',
            (event) => {
                if (
                    !tabletMedia.matches
                    || pointerStartX === null
                ) {
                    return;
                }

                const deltaX =
                    event.clientX
                    - pointerStartX;

                pointerStartX = null;

                if (Math.abs(deltaX) < 40) {
                    return;
                }

                if (deltaX < 0) {
                    goTo(activeIndex + 1);
                } else {
                    goTo(activeIndex - 1);
                }
            }
        );


        viewport.addEventListener(
            'pointercancel',
            () => {
                pointerStartX = null;
            }
        );


        const resizeObserver =
            new ResizeObserver(() => {
                updatePosition();
            });

        resizeObserver.observe(viewport);

        goTo(0, false);

        // Reveal Products after the initial layout has been painted.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                root.classList.add('is-ready');
            });
        });
    });
}


function initCareersFilters() {
    const careers = document.querySelector('.careers');

    if (!careers) {
        return;
    }

    const trigger = careers.querySelector('[data-careers-filter-trigger]');
    const filters = careers.querySelector('[data-careers-filters]');

    if (!trigger || !filters) {
        return;
    }

    trigger.addEventListener('click', () => {
        const isOpen = filters.classList.toggle('is-open');

        trigger.classList.toggle('is-active', isOpen);
        trigger.setAttribute('aria-expanded', String(isOpen));
    });
}


function initCareersJobFilters() {
    const careersComponent = document.querySelector('.careers');

    if (!careersComponent) {
        return;
    }

    const filterForm = careersComponent.querySelector(
        '[data-careers-filter-form]'
    );
    const positionsList = careersComponent.querySelector(
        '[data-careers-list]'
    );
    const ajaxUrl = filterForm?.dataset.ajaxUrl;

    if (!filterForm || !positionsList || !ajaxUrl) {
        return;
    }

    const filterGroups = [
        ...filterForm.querySelectorAll('[data-filter-group]'),
    ];

    filterGroups.forEach((group) => {
        const trigger = group.querySelector('[data-filter-trigger]');

        if (!trigger) {
            return;
        }

        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            filterGroups.forEach((otherGroup) => {
                if (otherGroup !== group) {
                    otherGroup.classList.remove('is-open');
                }
            });

            group.classList.toggle('is-open');
        });

        group.addEventListener('change', (event) => {
            if (event.target.type !== 'checkbox') {
                return;
            }

            const allCheckbox = group.querySelector(
                'input[value="all"]'
            );
            const otherCheckboxes = [
                ...group.querySelectorAll(
                    'input:not([value="all"])'
                ),
            ];

            if (!allCheckbox) {
                return;
            }

            const isAllClicked = event.target.value === 'all';

            if (isAllClicked && event.target.checked) {
                otherCheckboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                });
            } else if (!isAllClicked && event.target.checked) {
                allCheckbox.checked = false;
            }

            const anyOtherChecked = otherCheckboxes.some(
                (checkbox) => checkbox.checked
            );

            if (!anyOtherChecked && !allCheckbox.checked) {
                allCheckbox.checked = true;
            }

            const checkedBoxes = otherCheckboxes.filter(
                (checkbox) => checkbox.checked
            );
            const defaultText = trigger.dataset.default;
            const textSpan = trigger.querySelector(
                '.careers-filters__text'
            );

            if (textSpan) {
                if (checkedBoxes.length === 0) {
                    textSpan.textContent = defaultText;
                } else if (checkedBoxes.length === 1) {
                    textSpan.textContent = checkedBoxes[0].dataset.label;
                } else {
                    const labels = checkedBoxes
                        .map((checkbox) => checkbox.dataset.label)
                        .join(', ');

                    textSpan.textContent = labels.length > 20
                        ? `${checkedBoxes.length} selected`
                        : labels;
                }
            }

            fetchFilteredJobs();
        });
    });

    document.addEventListener('click', (event) => {
        filterGroups.forEach((group) => {
            if (!group.contains(event.target)) {
                group.classList.remove('is-open');
            }
        });
    });

    function fetchFilteredJobs() {
        positionsList.style.opacity = '0.5';

        const cleanFormData = new FormData();
        cleanFormData.append('action', 'filter_jobs');

        filterForm.querySelectorAll(
            'input:checked:not([value="all"])'
        ).forEach((checkbox) => {
            cleanFormData.append(checkbox.name, checkbox.value);
        });

        fetch(ajaxUrl, {
            method: 'POST',
            body: cleanFormData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Request failed with status ${response.status}`
                    );
                }

                return response.text();
            })
            .then((data) => {
                positionsList.innerHTML = data;
            })
            .catch((error) => {
                console.error('[Careers filters] Error:', error);
            })
            .finally(() => {
                positionsList.style.opacity = '1';
            });
    }
}


